import React, { useState, useImperativeHandle, useContext } from 'react';
import TContext from '../context'


export enum Events {
    NONE = 0, //无事件
    QUEREN_SUCAI = 1,
    EDIT_PATTERN = 2,
    CONFIRM_GRAFFITI = 3, //确认涂鸦
    CONFIRM_TEXT = 4, //确认文字
    CONFIRM_TEXT_PATTERN = 5, //确认文字纹样
    CONFIRM_FASHION = 6 //确认款式
}


export interface Action {
    setShow?: (s: boolean) => void; //显示
    setTitle?: (s: string) => void; //设置title文字
    registEvent?: (s: Events) => void; //注册事件
    setBottom?: (s: number) => void; //设置bottom
}

export interface Props {
    action?: any
}

export const Height = 30

const buttonClass = {
    padding: '8px 15px',
    backgroundColor: '#1890ff',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
    margin: '10px'
};


const Index = (props: Props) => {
    const [show, setShow] = useState<boolean>(false)
    const [bottom, setBottom] = useState<number>(0)
    const [title, setTitle] = useState<string>("编辑纹样")
    const [event, setEvent] = useState<Events>()
    const tc = useContext(TContext)

    const registEvent = (s: Events) => {
        tc?.setCurEvent!(s) //通知到全局
        setEvent(s)
    }

    useImperativeHandle(props.action, () => ({
        setShow,
        setTitle,
        registEvent,
        setBottom
    }));

    const handleFullscreen = () => {
        if (tc?.hasUnsavedChanges && tc?.curActivityObject && tc?.fabricClient) {
            const object = tc.curActivityObject;
            const canvaes = tc.fabricClient.canvaes;
            const currentCanvas = tc.curCutpartCode ? canvaes[tc.curCutpartCode] : undefined;


            if (!currentCanvas) return;

            // 画布尺寸
            const canvasWidth = 600;
            const canvasHeight = 600;
            const targetScale = canvasWidth / object.width;

            // 应用变换 - 直接使用画布尺寸
            object.set({
                scaleX: targetScale,
                scaleY: targetScale, // 保持宽高比
                left: canvasWidth / 2,
                top: canvasHeight / 2,
                originX: 'center',
                originY: 'center'
            });

            currentCanvas.renderAll();

            if (tc.markAsChanged) {
                tc.markAsChanged();
            }
        }
    };
    return (
        <div>
            <div style={{
                padding: "0 5px",
                display: 'flex',
                alignItems: 'center',
                width: "100%"
            }}>

                <button
                    style={tc?.hasUnsavedChanges && tc?.curActivityObject ? buttonClass : { ...buttonClass, opacity: 0.5, cursor: 'not-allowed' }}
                    onClick={handleFullscreen}
                    disabled={!tc?.hasUnsavedChanges || !tc?.curActivityObject}
                >
                    {t('占满画布')}
                </button>

                {/* <div style={{
                    flex: 1,
                    textAlign: 'center',
                    fontSize: 14,
                    fontWeight: 500
                }}>{t(title)}</div> */}
            </div>
        </div>

    )
}

export default Index
